/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axios from '../axios.js'
const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  updateUserInfo ({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
  updateUserRole ({ dispatch }, payload) {
    // Change client side
    payload.aclChangeRole(payload.userRole)

    // Make API call to server for changing role

    // Change userInfo in localStorage and store
    dispatch('updateUserInfo', {userRole: payload.userRole})
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////
  toggleSidebar ({ commit }, val) {
    commit('TOGGLE_SIDEBAR', val)
  },
  toggleModal({ commit }, val) {
    commit('TOGGLE_MODAL', val)
  },
  togglePdfViewer ({ commit }, val) {
    commit('TOGGLE_PDF_VIEWER', val)
  },
  setVendorInfo ({ commit }, val) {
    commit('SET_VENDOR_INFO', val)
  },
  setExpenses ({ commit }, val) {
    commit('SET_EXPENSES', val)
  },
  setAllStatus ({ commit }, val) {
    commit('SET_All_STATUS', val)
  },
  setStatusFilter ({ commit }, val) {
    commit('SET_STATUS_FILTER', val)
  },
  setDocumentTitle ({ commit }, val) {
    commit('SET_DOCUMENT_TITLE', val)
  }
}

export default actions
